import { FormControl, InputLabel } from '@mui/material';

interface ICasControl {
  // null renders the control bare, for callers that supply their own label (the SCE data
  // object header puts "Layout" to the left of the select).
  label: string | null;
  children: JSX.Element;
  shrink?: boolean;
}

export default function CasControl({ label, children, shrink }: ICasControl) {
  if (label === null) return children;
  return (
    <FormControl
      sx={{
        flexShrink: 0,
      }}
    >
      <InputLabel shrink={shrink}>{label}</InputLabel>
      {children}
    </FormControl>
  );
}
